<template>
  <div class="card-item">
    <!-- Drag handle -->
    <v-tooltip left color="surface_neutral_selected">
      <template v-slot:activator="{ on, attrs }">
        <div
          class="card-item__drag"
          role="button"
          tabindex="0"
          aria-label="Arraste para mover este item"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="text_secondary">mdi-drag</v-icon>
        </div>
      </template>
      <span>Segure e arraste para a coluna de exibição</span>
    </v-tooltip>

    <!-- Thumbnail -->
    <div class="card-item__media" @click="showModalImagem">
      <v-img
        v-if="item.thumbnail_url"
        :src="item.thumbnail_url"
        alt="Thumb câmera"
        contain
      />
      <CameraIcon
        v-else
        style="width: 64px; height: 64px; fill: var(--v-icon_default-base)"
      />
    </div>

    <!-- Body -->
    <div class="card-item__body">
      <div class="card-item__title">{{ item.nome }}</div>
      <div class="card-item__info">{{ item.descricao }}</div>
      <div class="card-item__meta">
        <span class="meta-source">{{ capitalize(item.praca.sig_praca) }}</span>
        <span class="meta-separator">&bull;</span>
        <span>{{ formatDate(item.created_at) }}</span>
        <span class="meta-separator">&bull;</span>
        <span>{{ formatHour(item.created_at) }}</span>
      </div>
    </div>

    <!-- Actions -->
    <div class="card-item__actions">
      <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on, attrs }">
          <div
            class="card-action-box card-action-box--move"
            v-bind="attrs"
            v-on="on"
            @click="moderarCamera"
           role="button" aria-label="Enviar para Coluna exibição">
            <v-icon>mdi-arrow-right</v-icon>
          </div>
        </template>
        <span>Enviar para Coluna exibição</span>
      </v-tooltip>

      <ModalEditarInfoCamera :camera-data="item" />

      <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on, attrs }">
          <div
            class="card-action-box card-action-box--favorite"
            :class="{ 'is-bursting': bursting }"
            role="button"
            :aria-label="item.flg_favorita ? 'Desfavoritar câmera' : 'Favoritar câmera'"
            v-bind="attrs"
            v-on="on"
            @click.prevent="handleFavoritarClick"
          >
            <v-icon v-if="!item.flg_favorita && !bursting">mdi-heart-outline</v-icon>
            <v-icon v-else>mdi-heart</v-icon>
            <span v-for="i in 5" :key="`hp-${i}`" :class="`heart-particle heart-particle--${i}`" aria-hidden="true">♥</span>
          </div>
        </template>
        <span>{{ item.flg_favorita ? "Desfavoritar câmera" : "Favoritar câmera" }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import { formatDate, formatHour } from "@/utils/dateUtils";
import { mapActions, mapGetters } from "vuex";
import ModalEditarInfoCamera from "../../Modal/Camera/ModalEditarInfoCamera.vue";
import CameraIcon from "@/assets/camera.svg";
export default {
  props: {
    item: Object,
    currentPage: Number,
    isFavoritaTab: Boolean,
  },
  components: { ModalEditarInfoCamera, CameraIcon },

  data() {
    return {
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      bursting: false,
    };
  },
  computed: {
    ...mapGetters({}),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    cod_producao() {
      return this.$store.state.producoes.selectedProducao.cod_producao;
    },
  },
  methods: {
    ...mapActions({
      getCameras: "cameras/getCameras",
      getCamerasModeradas: "cameras/getCamerasModeradas",
    }),
    formatDate,
    formatHour,
    async showModalImagem(midia_url_aprovadas) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("text/plain", JSON.stringify(item));
    },
    async moderarCamera() {
      const formData = {
        id_camera: this.item.id,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        dsc_login_moderacao: this.$store.state.users.user.dsc_login_usuario,
      };

      await apiClient
        .post("cameras/moderarCamera", formData)
        .then(async () => {
          await this.getCameras({
            cod_praca: this.$store.state.cameras.selectedPraca.cod_praca,
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            filtro_texto: this.$store.state.cameras.filtroCameras,
            flg_favorita: this.$store.state.cameras.flg_favorita,
            page: this.currentPage,
            size: 5,
          });
          await this.getCamerasModeradas({
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            page: this.currentPage,
            size: 5,
            filtro_texto: this.$store.state.cameras.filtroCamerasModeradas,
            flg_favorita: this.$store.state.cameras.flg_favorita,
          });
          const { data } = await apiClient.get(
            `/cameras/checkIfPodExists/${formData.id_camera}`
          );
          if (!data.pod) {
            await apiClient.post(`/cameras/${formData.id_camera}/stream`);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    handleFavoritarClick() {
      // Fire the heart-burst flourish only when going from un-favorited → favorited.
      if (!this.item.flg_favorita) {
        this.bursting = true;
        setTimeout(() => { this.bursting = false; }, 900);
      }
      this.favoritarCamera();
    },

    async favoritarCamera() {
      try {
        await apiClient
          .patch(`/cameras/${this.item.id}/favoritar`, {
            flg_favorita: !this.item.flg_favorita,
          })
          .then(async () => {
            await this.getCameras({
              cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
              page: this.currentPage,
              size: 5,
              filtro_texto: this.$store.state.cameras.filtroCamerasModeradas,
              flg_favorita: this.$store.state.cameras.flg_favorita,
            });
            this.$toast.success("Câmera favoritada com sucesso");
          });
      } catch (error) {
        console.error(error);
        this.$toast.error("Não foi possível favoritar a câmera");
      }
    },
  },
};
</script>
